import { X } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { Badge } from "@/components/ui/badge";

export interface FilterPill {
    id: string;
    label: string;
}

interface FilterPillsProps {
    filters: FilterPill[];
    onRemove: (id: string) => void;
    onClearAll?: () => void;
}

export function FilterPills({
    filters,
    onRemove,
    onClearAll,
}: FilterPillsProps) {
    if (filters.length === 0) return null;

    return (
        <div className="flex flex-wrap items-center gap-1.5">
            <AnimatePresence mode="popLayout">
                {filters.map((filter) => (
                    <motion.div
                        key={filter.id}
                        layout
                        initial={{ opacity: 0, scale: 0.85 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.85 }}
                        transition={{ duration: 0.15 }}
                    >
                        <Badge
                            variant="secondary"
                            className="cursor-default gap-1 pr-1 font-normal"
                        >
                            {filter.label}
                            <button
                                type="button"
                                onClick={() => onRemove(filter.id)}
                                className="hover:bg-foreground/10 rounded-full p-0.5 transition-colors"
                                aria-label={`Remove ${filter.label} filter`}
                            >
                                <X className="size-3" />
                            </button>
                        </Badge>
                    </motion.div>
                ))}
            </AnimatePresence>
            {filters.length >= 2 && onClearAll && (
                <button
                    type="button"
                    onClick={onClearAll}
                    className="text-muted-foreground hover:text-foreground ml-1 text-xs transition-colors"
                >
                    Clear all
                </button>
            )}
        </div>
    );
}
